import styled from "styled-components";
import { Image as FurImage } from "./../../../components/util";

export const Image = styled(FurImage)`
  max-height: 200px;
`;
